import changeCase from 'change-case-object'

export const threadContext = changeCase.camelCase({
  thread_type: 'USER_TO_PAGE',
  tid: process.env.REACT_APP_FB_TESTUSER_ID,
  psid: process.env.REACT_APP_FB_TESTUSER_ID,
  signed_request: process.env.REACT_APP_FB_TESTUSER_SIGN
})

export default {
  getContext(appId) {
    return Promise.resolve(threadContext)
  },
  requestCloseBrowser() {
    console.log('[MessengerExtensions] Close triggered')
    return Promise.resolve()
  },
  beginShareFlow(message) {
    console.log('[MessengerExtensions] Share flow started. Message: ', message)
    return Promise.resolve()
  }
}



// WEBPACK FOOTER //
// ./src/lib/messengerExtensions.development.js